import { render, staticRenderFns } from "./worksItem.vue?vue&type=template&id=4ca49c14&"
import script from "./worksItem.vue?vue&type=script&lang=js&"
export * from "./worksItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports